import { CardPartProperties, useCardPartProperties } from "./CardPartProperties";
import { ControlType, FetchStatus } from "../../../../base/types";
import { ErrorMessage, Spinner } from "../../../../widgets";

import { CardPart } from "./CardPart";
import { DraftCardPartComponent } from "./DraftCardPartComponent";
import { FC } from "react";
import { IControlAttributes } from "../../../../base/models";
import { Registry } from "../../../../base/register";

export const CardPartComponent: FC<IControlAttributes> = ({
    className, props
}) => {
    const { status, properties, error } = useCardPartProperties(props)

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    return <>
        <CardPart {...properties}
            className={className} />
    </>
}


Registry.addControl({
    id: "6f9fe856-5aab-472e-a482-ec3c733169bc",
    name: "Card Part",
    type: ControlType.CardPart,
    properties: CardPartProperties,
    component: CardPartComponent,
    draftComponent: DraftCardPartComponent
})
